module.exports = __webpack_public_path__ + "assets/img/icon-bankcard.ab1fe5ab.png";